import React from 'react';
import { IconContext } from 'react-icons';
import {
  FaGithub,
  FaLinkedin,
  FaInstagram,
  FaBehance,
  FaEnvelope,
  FaTwitter,
  FaHackerrank
} from 'react-icons/fa';
import {
  Container,
} from './styles';

const Social = () => (
  <Container>
    <IconContext.Provider value={{ size: '32px', color: '#5e17eb' }}>
      <a href="https://github.com/biachacon" target="_blank" rel="noopener noreferrer">
        <FaGithub />
      </a>
      <a href="https://www.hackerrank.com/biachacon" target="_blank" rel="noopener noreferrer">
        <FaHackerrank />
      </a>
      <a href="https://linkedin.com/in/bheatrizchacon" target="_blank" rel="noopener noreferrer">
        <FaLinkedin />
      </a>
      <a href="https://instagram.com/bheatrizchacon" target="_blank" rel="noopener noreferrer">
        <FaInstagram />
      </a>
      <a href="https://twitter.com/biachacondev" target="_blank" rel="noopener noreferrer">
        <FaTwitter />
      </a>
      <a href="https://behance.net/biachacon" target="_blank" rel="noopener noreferrer">
        <FaBehance />
      </a>
      <a href="/#contact">
        <FaEnvelope />
      </a>
    </IconContext.Provider>
  </Container>
);
export default Social;
